import { bearerAuthOptions } from "./util";
import { apiUrl } from "../config";
import axios from "axios";

export function getBookmarks(language) {
	const options = { ...bearerAuthOptions };
	if (language) {
		options.headers = { ...options.headers, "Accept-Language": language };
	}
	return axios.get(`${apiUrl}/bookmarks`, options).then(r => r.data);
}

export function bookmarkClass(classID) {
	return axios.post(`${apiUrl}/bookmark/add`, { classID }, bearerAuthOptions).then(r => r.data);
}

export function removeBookmark(classID) {
	return axios
		.post(`${apiUrl}/bookmark/delete`, { classID }, bearerAuthOptions)
		.then(r => r.data);
}



// WEBPACK FOOTER //
// ./src/api/bookmark.js